import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";
import Utils from "../Utils";
var dateFormat = require("dateformat");

export default ({ userCache }) => {
  const [storyChats, setStoryChats] = useState([]);

  useEffect(() => {
    adminRecords.collection('storyChats')
      .orderBy('createdAt', 'asc')
      .get().then(snapshot => {
        const chatsData = [];
        snapshot.forEach(doc => chatsData.push({ ...doc.data(), id: doc.id }));
        const uniqueUserIds = [...new Set(chatsData.map(chat => chat.userId))];

        userCache.fetchIds(uniqueUserIds).then(() => {
          setStoryChats(chatsData);
        });
      });

  }, []);

  const groupedChats = storyChats.reduce((groups, chat) => {
    const key = chat.projectId;
    if (!groups[key]) {
      groups[key] = { chats: [], user: userCache.getUser(chat.userId) };
    }
    groups[key].chats.push(chat);
    return groups;
  }, {});

  return (
    <div>
      {Object.keys(groupedChats).map(key => {
        return <div key={key}>
          <h2>Project ID: {key} from {groupedChats[key].user?.email}</h2>

          {groupedChats[key].chats.map(chat => {
            return <div key={chat.id}>
              <p><strong>{chat.role}:</strong> {Utils.nl2br(chat.content)}</p>
              <br/>
            </div>;
          })}
          <br/><br/>
        </div>;
      })}


    </div>
  );

};
